module.exports = __webpack_public_path__ + "static/media/guidance_2.71322b66.png";